import { useStartTransaction } from '../api/start-transaction';
import { useBankIDUrl } from '../hooks/use-bankid-url';

import { useDevice } from '@/hooks/shared/use-device';
import { cn } from '@/lib/utils';
import { ExternalLink, QrCodeIcon } from 'lucide-react';
import { LoadingButton } from '@/shared/components/ui/buttons/loading-button';

type StartTransactionProps = {
  setTransactionId: (value: string) => void;
  setShowQR: (value: boolean) => void;
  showQR: boolean;
};

export function StartTransaction({ setTransactionId, setShowQR, showQR }: StartTransactionProps) {
  const device = useDevice();
  const getBankIDUrl = useBankIDUrl();
  const mutation = useStartTransaction({
    mutationConfig: {
      onSuccess: (data) => {
        setTransactionId(data.id);
        if (!showQR) window.location.href = getBankIDUrl(data.autoStartToken, data.id);
      },
    },
  });

  const handleClick = (qr: boolean) => {
    setShowQR(qr);
    mutation.mutate(undefined);
  };

  return (
    <>
      <h3 className="text-xl leading-relaxed font-semibold mt-6 mb-2">Starta BankID-Verifiering</h3>

      <div className={cn('flex gap-4', !device.isMobileOrTablet && 'flex-row-reverse')}>
        <LoadingButton
          isLoading={mutation.isPending && !showQR}
          onClick={() => handleClick(false)}
          variant={device.isMobileOrTablet ? 'default' : 'outline'}
        >
          <div className="flex items-center gap-2">
            Öppna BankID
            <ExternalLink size={16} aria-hidden="true" />
          </div>
        </LoadingButton>
        <LoadingButton
          isLoading={mutation.isPending && showQR}
          onClick={() => handleClick(true)}
          variant={device.isMobileOrTablet ? 'outline' : 'default'}
        >
          <div className="flex items-center gap-2">
            <QrCodeIcon size={16} aria-hidden="true" /> Visa QR-kod
          </div>
        </LoadingButton>
      </div>
    </>
  );
}
